/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminGroupSaleListProduct,
    AdminGroupSaleListProductFromJSON,
    AdminGroupSaleListProductFromJSONTyped,
    AdminGroupSaleListProductToJSON,
} from './AdminGroupSaleListProduct';
import {
    AdminGroupSaleMarketplace,
    AdminGroupSaleMarketplaceFromJSON,
    AdminGroupSaleMarketplaceFromJSONTyped,
    AdminGroupSaleMarketplaceToJSON,
} from './AdminGroupSaleMarketplace';
import {
    AdminGroupSaleStatus,
    AdminGroupSaleStatusFromJSON,
    AdminGroupSaleStatusFromJSONTyped,
    AdminGroupSaleStatusToJSON,
} from './AdminGroupSaleStatus';

/**
 * 
 * @export
 * @interface AdminGroupSaleDetail
 */
export interface AdminGroupSaleDetail {
    /**
     * 
     * @type {string}
     * @memberof AdminGroupSaleDetail
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof AdminGroupSaleDetail
     */
    id: string;
    /**
     * 
     * @type {Array<AdminGroupSaleMarketplace>}
     * @memberof AdminGroupSaleDetail
     */
    marketplaces?: Array<AdminGroupSaleMarketplace>;
    /**
     * 
     * @type {string}
     * @memberof AdminGroupSaleDetail
     */
    name: string;
    /**
     * 
     * @type {Array<AdminGroupSaleListProduct>}
     * @memberof AdminGroupSaleDetail
     */
    products?: Array<AdminGroupSaleListProduct>;
    /**
     * 
     * @type {string}
     * @memberof AdminGroupSaleDetail
     */
    soldDate?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminGroupSaleDetail
     */
    soldPrice: number;
    /**
     * 
     * @type {AdminGroupSaleStatus}
     * @memberof AdminGroupSaleDetail
     */
    status: AdminGroupSaleStatus;
    /**
     * 
     * @type {string}
     * @memberof AdminGroupSaleDetail
     */
    updatedAt: string;
}



export function AdminGroupSaleDetailFromJSON(json: any): AdminGroupSaleDetail {
    return AdminGroupSaleDetailFromJSONTyped(json, false);
}

export function AdminGroupSaleDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminGroupSaleDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'createdAt': json['createdAt'],
        'id': json['id'],
        'marketplaces': !exists(json, 'marketplaces') ? undefined : ((json['marketplaces'] as Array<any>).map(AdminGroupSaleMarketplaceFromJSON)),
        'name': json['name'],
        'products': !exists(json, 'products') ? undefined : ((json['products'] as Array<any>).map(AdminGroupSaleListProductFromJSON)),
        'soldDate': !exists(json, 'soldDate') ? undefined : json['soldDate'],
        'soldPrice': json['soldPrice'],
        'status': AdminGroupSaleStatusFromJSON(json['status']),
        'updatedAt': json['updatedAt'],
    };
}

export function AdminGroupSaleDetailToJSON(value?: AdminGroupSaleDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'createdAt': value.createdAt,
        'id': value.id,
        'marketplaces': !value.marketplaces ? undefined : ((value.marketplaces as Array<any>).map(AdminGroupSaleMarketplaceToJSON)),
        'name': value.name,
        'products': !value.products ? undefined : ((value.products as Array<any>).map(AdminGroupSaleListProductToJSON)),
        'soldDate': value.soldDate,
        'soldPrice': value.soldPrice,
        'status': AdminGroupSaleStatusToJSON(value.status),
        'updatedAt': value.updatedAt,
    };
}

